/**
 * The model representing the question
 * @class
 */
Selector.Model.Question = Backbone.Model.extend(
/** @lends Selector.Model.Question# */
{
	idAttribute: "ID",

    defaults: {
	    "ACTIVE": false,
        "ANSWER": null,
        "CURRENT": false,
        "ERROR": null,
    },

    resetModel: function(){
        this.set("ACTIVE", false);
        this.set("ANSWER", null);
        this.set("CURRENT", false);
        this.set("WARNING", null);
        this.set("EVM", null);
    },

    activate: function(){
	    this.collection.activateQuestion(this);
    }
	
});